module.exports = __webpack_public_path__ + "img/200101.99660dce.png";